import NotificationType from '@/models/enums/notification/NotificationType'
import { unseenCount } from '@/components/support/notifications'

const state = {
    showDialog: false,
    unseenNotificationsCount: 0,
    // Повод перечитать колокольчик: страница тикета поддержки погасила уведомления на сервере.
    refreshTick: 0,
}

const getters = {
    getStorageKey (state, getters, rootState, rootGetters) {
        return `filial.${rootGetters['branches/getLocalStorageBranch'].id}.notifications`
    },
}

const actions = {
    calcNotificationsCount ({ state, dispatch, getters }, notifications) {
        const json = localStorage.getItem(getters.getStorageKey)
        const data = json ? JSON.parse(json) : null

        if (data && new Date(data.date).getDate() === new Date().getDate()) {
            state.unseenNotificationsCount = unseenCount(notifications, data.viewedNotificationIds)
        } else {
            state.unseenNotificationsCount = unseenCount(notifications, [])
            dispatch('storeViewedNotifications', [])
        }
    },
    storeViewedNotifications ({ getters }, notifications) {
        // Уведомления поддержки сюда не попадают: открыть выпадайку не значит прочитать их.
        const data = {
            date: new Date().toISOString(),
            viewedNotificationIds: notifications
                .filter(item => !NotificationType.isSupport(item.type))
                .map(item => item.id),
        }

        localStorage.setItem(getters.getStorageKey, JSON.stringify(data))
    },
    viewNotifications ({ state, dispatch }, notifications) {
        state.unseenNotificationsCount = unseenCount(notifications.filter(item => NotificationType.isSupport(item.type)), [])
        dispatch('storeViewedNotifications', notifications)
    },
    requestRefresh ({ state }) {
        state.refreshTick++
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
}
